import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Footer/footer.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Hero/contact.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Hero/hero.jsx");
